import { StatisticsParams, StatisticsFilter, DateRange } from "@/store/expenses/statistics";
import { formatDateToYYYYMMDD } from "@/services/utils/DateParser";

export interface TableSettings {
  first: number;
  orderField: string;
  filter: StatisticsFilter;
}

export function setStatisticsParamsByFilter(
  params: StatisticsParams,
  settings: TableSettings
) {
  if (Object.keys(settings.filter).length > 0) {
    if (settings.filter.brand && settings.filter.brand.length > 0) {
      params.brand_pk__in = settings.filter.brand.join(",");
    }

    if (settings.filter.segment && settings.filter.segment.length > 0) {
      params.segment_id__in = settings.filter.segment.join(",");
    }

    if (settings.filter.ads_cabinet && settings.filter.ads_cabinet.length > 0) {
      params.ads_cabinet_id__in = settings.filter.ads_cabinet.join(",");
    }

    if (settings.filter.state && settings.filter.state.length > 0) {
      params.campaign_segment_state_id__in = settings.filter.state.join(",");
    }

    if (settings.filter.platform && settings.filter.platform.length > 0) {
      params.source_slug__in = settings.filter.platform.join(",");
    }

    if (settings.filter.date) {
      const dateRange = settings.filter.date as DateRange;
      if (dateRange.start_date) {
        const startDate = dateRange.start_date instanceof Date
          ? dateRange.start_date
          : new Date(dateRange.start_date);
        params.start_date = formatDateToYYYYMMDD(startDate);
      }
      if (dateRange.end_date) {
        const endDate = dateRange.end_date instanceof Date
          ? dateRange.end_date
          : new Date(dateRange.end_date);
        params.end_date = formatDateToYYYYMMDD(endDate);
      }
    }
  }
}

